module.exports = __webpack_public_path__ + "static/1-2-8417405c8a33174250001971cb2e1966.jpg";